import { PASS_RECOMMENDATION_KEY, PASS_SECTION_KEY } from '~constants/pass';

import type { TransportationProduct } from '~models/Transportation/PointToPointTicket';
import type { PassRecommendationKey, PassSectionKey } from '~types/pass';

export function classifyProductsByCountry(products: TransportationProduct[]) {
  return products.reduce(
    (acc, product) => {
      const { keyName } = product.country;
      switch (true) {
        case keyName.includes(PASS_SECTION_KEY.Switzerland):
          acc[PASS_SECTION_KEY.Switzerland].push(product);
          break;
        case keyName.includes(PASS_SECTION_KEY.Italy):
          acc[PASS_SECTION_KEY.Italy].push(product);
          break;
        case keyName.includes(PASS_SECTION_KEY.Germany):
          acc[PASS_SECTION_KEY.Germany].push(product);
          break;
        case keyName.includes(PASS_SECTION_KEY.France):
          acc[PASS_SECTION_KEY.France].push(product);
          break;
        default:
          acc[PASS_SECTION_KEY.Europe].push(product);
      }
      return acc;
    },
    {
      [PASS_SECTION_KEY.Europe]: [],
      [PASS_SECTION_KEY.Switzerland]: [],
      [PASS_SECTION_KEY.Italy]: [],
      [PASS_SECTION_KEY.Germany]: [],
      [PASS_SECTION_KEY.France]: [],
    } as Record<Exclude<PassSectionKey, 'ALL'>, TransportationProduct[]>,
  );
}

const PASS_RECOMMENDATION_KEYS: PassRecommendationKey[] = Object.values(PASS_RECOMMENDATION_KEY);

export function classifyProductsByRecommendation(products: TransportationProduct[]) {
  return PASS_RECOMMENDATION_KEYS.reduce((acc, key) => {
    if (key !== PASS_RECOMMENDATION_KEY.EUROPE_REGIONAL) {
      const productsByRecommendation = products.filter(
        ({ supplier }) => supplier.value === `RAIL_EUROPE_PASS_${key}`,
      );

      acc[key] = productsByRecommendation;
    } else {
      const productsByRecommendation = products.filter(
        ({ supplier }) =>
          supplier.value !== `RAIL_EUROPE_PASS_${PASS_RECOMMENDATION_KEY.SWISS}` &&
          supplier.value !== `RAIL_EUROPE_PASS_${PASS_RECOMMENDATION_KEY.EUROPE}`,
      );

      acc[key] = productsByRecommendation;
    }

    return acc;
  }, {} as Record<PassRecommendationKey, TransportationProduct[]>);
}
